import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function DocumentDialog({ title, open, children, onClose }) {
  return (
    <>
      <Dialog fullWidth maxWidth="md" open={open} onClose={onClose} aria-labelledby="max-width-dialog-title">
        <DialogTitle id="max-width-dialog-title">{title.toUpperCase()}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
